// extracted by mini-css-extract-plugin
export var parcelRow = "_ty-0";